<script lang="ts">
  import { fade } from 'svelte/transition';

  let { message = '', fadeDuration = 500 }: { message?: string; fadeDuration?: number } = $props();

  let fadeDurationHalf = $derived(fadeDuration / 2);
</script>

<div class="message-area relative mt-3 flex justify-center">
  {#if message}
    {#key message}
      <div
        class="absolute rounded-sm bg-prim p-3 text-center"
        in:fade={{ duration: fadeDuration }}
        out:fade={{ duration: fadeDurationHalf, delay: fadeDuration }}
      >
        <span
          class="text-muted-foreground text-sm"
          in:fade={{
            duration: fadeDurationHalf,
            delay: fadeDurationHalf,
          }}
          out:fade={{ duration: fadeDurationHalf }}
        >
          {message}
        </span>
      </div>
    {/key}
  {/if}
</div>

<style>
  .message-area {
    min-height: 1.5em;
  }
</style>
